import { render, staticRenderFns } from "./DialogRoomEdit.vue?vue&type=template&id=4c4b219c&scoped=true&"
import script from "./DialogRoomEdit.vue?vue&type=script&lang=js&"
export * from "./DialogRoomEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4b219c",
  null
  
)

export default component.exports